export default __webpack_public_path__ + "static/media/Clap2.88e03be0.mp3";